import request from '@/utils/request'

// 请假申请
export const quashLeave = (data = {}) => request({ url: `/api/estate/v1/workflow/quashLeave`, method: 'post', data })

export const approvalCancelVacation = (data = {}) => request({ url: `/api/estate/v1/workflow/approvalCancelVacation`, method: 'post', data })

export const submitFlowVacationApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowVacationApply`, method: 'post', data })

export const calcVacationDuration = (data = {}) => request({ url: `/api/estate/v1/workflow/calcVacationDuration`, method: 'post', data })

// 补卡申请
export const flowMendDetailIns = (data = {}) => request({ url: `/api/estate/v1/workflow/flowMendDetailIns`, method: 'post', data })

// 出差申请
export const submitFlowTravelApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowTravelApply`, method: 'post', data })

// 用章申请
export const flowUseSealIns = (data = {}) => request({ url: `/api/estate/v1/workflow/flowUseSealIns`, method: 'post', data })

// 报销申请
export const submitFlowReimbursementApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowReimbursementApply`, method: 'post', data })

// 采购申请
export const submitFlowPurchaseApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowPurchaseApply`, method: 'post', data })

export const materialsCategoryStockList = (data = {}) => request({ url: `/api/estate/v1/oa/materialsCategoryStockList`, method: 'post', data })

// 物资申领
export const submitFlowMaterialApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowMaterialApply`, method: 'post', data })

// 待我审核
export const applyPage = (data = {}) => request({ url: `/api/estate/v1/workflow/applyPage`, method: 'post', data })

export const applyCount = (data = {}) => request({ url: `/api/estate/v1/workflow/applyCount`, method: 'post', data })

// 审核记录
export const flowAuditLogPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowAuditLogPage`, method: 'post', data })

export const flowAuditLogCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowAuditLogCount`, method: 'post', data })
